export {};

declare global {
	interface String {
		capitalize(): string
        kebabize(): string
		toNumber(): number
		isNumber(): boolean
		crc32(): number
		nl2br(): String
	}
}


Object.defineProperty(String.prototype, 'capitalize', {
	enumerable: false,
	value: function (): string {
		return this.charAt(0).toUpperCase() + this.slice(1);
	}
})

Object.defineProperty(String.prototype, 'kebabize', {
	enumerable: false,
	value: function (): string {
        return this.normalize("NFD").replace(/\p{Diacritic}/gu, "")
                   .replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, '-')
                   .toLowerCase()
                   .replace(/-+/g, '-');
	}
})

Object.defineProperty(String.prototype, 'toNumber', {
	enumerable: false,
	value: function(): number {
		return parseInt((this + '').replace(/[^\d\.]/gim, ''));
	}
})

Object.defineProperty(String.prototype, 'isNumber', {
	enumerable: false,
	value: function(): boolean {
		return this == this.toNumber();
	}
})

Object.defineProperty(String.prototype, 'nl2br', {
	enumerable: false,
	value: function(): string {
		return (this + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
	}
})

const CRC32TABLE = new Uint32Array(256).map((_, i) => {
	for(let k=8; k--;) i = i & 1 ? 3988292384 ^ i >>> 1 : i >>> 1;
    return i;
})

Object.defineProperty(String.prototype, 'crc32', {
	enumerable: false,
	value: function (): number {
	let crc = -1;

	for(let i=0, l=this.length; i<l; i++)
		crc = crc >>> 8 ^ CRC32TABLE[ crc & 255 ^ this.charCodeAt(i) ];

		return (crc ^ -1) >>> 0;
	}
})